// extracted by mini-css-extract-plugin
export default {"carregador":"Carregador_carregador__KC6Dq","icone":"Carregador_icone__h1oWZ","small":"Carregador_small__KTAci"};